import React from 'react';
import { useTranslation } from 'react-i18next';

import { Logout } from '@app/components/Logout/Logout';
import { NAMESPACE } from '@app/i18n';

interface ErrorMessageProps {
  /** The error message to display to the user */
  message: string;
  /** The user's login ID for support purposes */
  loginId: string | undefined;
}

/**
 * ErrorMessage component displays authentication and loading errors.
 *
 * Shows the error message, user ID for support purposes, and provides
 * a logout option for the user to try again.
 */
export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  loginId,
}) => {
  const { t } = useTranslation(NAMESPACE.APP_SHELL);

  return (
    <div className="text-container">
      {/* eslint-disable-next-line react/jsx-no-literals */}
      <div className="connectingText error">{`${message}\n`}</div>
      <div>{t('routes.userId', { loginId })}</div>
      <div>{t('routes.contactSupport')}</div>
      <Logout />
    </div>
  );
};
